// extracted by mini-css-extract-plugin
export default {"wrapper":"gx-z","viewport":"hx-z","container":"ix-z","slide":"jx-z"};